export const COMPANY_PAGE = {
  PROFILE: "profile",
  ORGANIZATION: "organization",
  POSITION: "position",
  CONDITION_WORKING: "condition.working",
  CONDITION_OVERTIME: "condition.overtime",
  BRANCH_LIST: "branch_list",
  DOCUMENT: "document",
};

export const COMPANY_PAGE_LIST = Object.values(COMPANY_PAGE);
